<div *ngIf="!loaded">Cargando datos...</div>
<app-alert></app-alert>

<div class="dashboard dashboard-container">
  <!-- 🟦 Panel Principal -->
  <div class="dashboard-principal">
    <!-- 🧭 Encabezado -->
    <div class="header-dashboard">
      <div class="title-section">
        <h1 class="d-none d-md-block">Dashboard</h1>
        <p>
          Revisa el resumen del estado de tus despachos del mes y el estado de tus guías.
        </p>
      </div>
      <div class="date-section">
        <input type="date" [(ngModel)]="fechaInicio" (change)="onDateChange()" name="fechaInicio" />
        <span>-</span>
        <input type="date" [(ngModel)]="fechaFin" (change)="onDateChange()" name="fechaFin" />
      </div>
    </div>

    <!-- 🧱 Contenedor principal con scroll -->
    <div class="scroll-container">
      <div class="main-grid">
        <!-- 🚚 Despacho de hoy -->
        <div class="card large">
          <div class="card-header">
            <h2>Despacho actual</h2>
            <a [routerLink]="['/pedidospendiente']">Ir a despacho <span class="image"></span></a>
          </div>

          <div *ngIf="pedidoHoy; else noDespacho" class="today-content">
            <div class="image">

            </div>
            <div class="info">
              <p>
                <strong>Fecha entrega:</strong>
                {{ pedidoHoy.deliveryDate | date: 'dd/MM/yyyy' }}
                {{ pedidoHoy.deliveryTime }}
              </p>
              <p><strong>Dirección:</strong> {{ pedidoHoy.address }}</p>
              <p><strong>Obra:</strong> {{ pedidoHoy.project }}</p>
              <p><strong>Producto:</strong> {{ pedidoHoy.product }}</p>
              <p><strong>Cantidad:</strong> {{ pedidoHoy.quantity }}</p>
              
            </div>
            <!-- ✅ estado usando el mismo mapeo -->
            <div class="status" [ngClass]="getEstadoClass(pedidoHoy)">
              {{ getEstadoPlano(pedidoHoy) }}
            </div>
          </div>

          <ng-template #noDespacho>
            <p class="empty-despacho">
              No hay despachos pendientes en curso.
            </p>
          </ng-template>
        </div>

        <!-- 📊 Historial de despachos -->
        <div class="card full">
          <div class="card-header">
            <h2>Historial de despachos</h2>
            <a [routerLink]="isOnline ? ['/pedidosEntregados'] : null"
               (click)="!isOnline && onLockedNavClick()"
               [class.nav-offline-disabled]="!isOnline">Ir a historial <span class="image"></span></a>
          </div>

          <!-- 🟦 Tabs de filtro -->
          <div class="tabs-historial">
            <button [class.active]="selectedHistorialTab === 'pendientes'" (click)="setHistorialTab('pendientes')"
              class="tab tab-pendientes">
              <div class="secction-title"> <span class="pendientes-icon"></span>Pendientes</div>
              <div class="secction-value">{{ pendientes }}</div>

            </button>
            <button [class.active]="selectedHistorialTab === 'entregados'" (click)="setHistorialTab('entregados')"
              class="tab tab-entregados">
              <div class="secction-title"> <span class="entregados-icon"></span>Entregados </div>
              <div class="secction-value">{{ entregados }}</div>

            </button>
            <button [class.active]="selectedHistorialTab === 'anulados'" (click)="setHistorialTab('anulados')"
              class="tab tab-anulados">

              <div class="secction-title"> <span class="anulados-icon"></span>Anulados </div>
              <div class="secction-value">{{ anulados }}</div>

            </button>
          </div>

          <div class="despacho-container">
            <!-- 📋 Lista filtrada -->
            <div class="history-scroll">
              <div *ngFor="let item of filteredHistorial" class="history-item" [ngClass]="{
          'historial-pendiente': getEstadoPlano(item) === 'pendiente',
          'historial-entregado': getEstadoPlano(item) === 'entregado',
          'historial-anulado': getEstadoPlano(item) === 'anulado'
        }">
                <div>
                  <span class="state-icon"></span>
                </div>

                <div>
                  <p><strong>N° pedido:</strong> {{ item.orderNumber }}</p>
                  <p> {{ item.deliveryDate }}</p>
                </div>

                <div>
                  <p><strong>Dirección:</strong> {{ item.address }}</p>
                  <p><strong>Obra:</strong> {{ item.project }}</p>
                </div>



              </div>
            </div>

            <!-- 📈 Gráfico -->
            <div class="chart-area">
              <canvas baseChart [datasets]="chartData" [labels]="chartLabels" [options]="firmadasChartOptions"
                [legend]="true" [type]="'bar'">
              </canvas>
            </div>
          </div>
        </div>


        <!-- 📦 Guías -->
        <div class="card small">
          <div class="card-header">
            <h2>Guías</h2>
            <a [routerLink]="['/pedidosEntregados']">Ir a historial <span class="image"></span></a>
          </div>

          <div class="guides-summary">
            <!-- 🟦 Tabs -->
            <div class="tabs-guides">
              <button [class.active]="selectedTab === 'firmadas'" (click)="setTab('firmadas')" class="tab tab-firmadas">

                <div class="secction-title"> <span class="firmadas-icon"></span>Firmadas </div>
                <div class="secction-value">{{ guias_firmadas }}</div>
              </button>
              <button [class.active]="selectedTab === 'noFirmadas'" (click)="setTab('noFirmadas')"
                class="tab tab-nofirmadas">
                <div class="secction-title"> <span class="no-firmadas-icon"></span>No firmadas </div>
                <div class="secction-value">{{ guias_no_firmadas }}</div>

              </button>
              <button [class.active]="selectedTab === 'rechazadas'" (click)="setTab('rechazadas')"
                class="tab tab-rechazadas">
                <div class="secction-title"> <span class="rechazadas-icon"></span>Rechazadas </div>
                <div class="secction-value">{{ guias_rechazadas }}</div>

              </button>
            </div>

            <!-- 🟠 Gráfico -->
            <div class="guides-chart">
              <canvas class="guides-chart-canvas" baseChart [datasets]="firmadasChartData"
                [labels]="firmadasChartLabels" [options]="firmadasChartOptions" [type]="'doughnut'"></canvas>
            </div>

            <div class="guides-legend" aria-label="Resumen de guías">
              <div class="guides-legend-item guides-legend-signed"><span class="guides-legend-color"></span><span>Firmadas</span><strong>{{ guias_firmadas }}</strong></div>
              <div class="guides-legend-item guides-legend-unsigned"><span class="guides-legend-color"></span><span>No firmadas</span><strong>{{ guias_no_firmadas }}</strong></div>
              <div class="guides-legend-item guides-legend-rejected"><span class="guides-legend-color"></span><span>Rechazadas</span><strong>{{ guias_rechazadas }}</strong></div>
            </div>

            <!-- 📋 Lista filtrada -->
            <div class="guide-list scrollable-guides">
              <div *ngFor="let g of filteredGuias" class="despacho-item" [ngClass]="{
      'guide-firmada': g.guideState === 'signed',
      'guide-no-firmada': g.guideState === 'unsigned',
      'guide-rechazada': g.guideState === 'rejected'
    }">
                <p><strong>Pedido:</strong> {{ g.orderNumber }}</p>
                <p class="d-flex align-items-center mb-0">
                  <strong class="me-2">Guía: {{g.guideNumber}}</strong>

                  <!-- <app-pedidos-pendiente-visualizarguia [rutaPdf]="g.LINK" [numGuia]="g.guideNumber">
                  </app-pedidos-pendiente-visualizarguia> -->
                </p>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<div class="offline-nav-toast" *ngIf="showOfflineToast">
  No disponible sin conexión
</div>

<!-- <app-modal-encuesta></app-modal-encuesta> -->

<!-- 🟢 Modal de aviso
<div class="modal-overlay" (click)="closeModal()" *ngIf="showModal">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <span class="modal-close" (click)="closeModal()">X</span>
    <h6 class="modal-title">Estado activo</h6>
    <p class="modal-text">
      Recuerda que el estado se mantendrá en
      <span class="modal-title">2 horas</span> de tiempo
      <span class="modal-title">activo</span>. Si no hay actividad, cambiará a
      <span class="modal-title">ausente</span> y no recibirás pedidos.
    </p>
    <img src="/assets/images/icons/userActivo.svg" alt="Usuario activo" class="modal-image" />
    <button class="btn-primary" (click)="closeModal()">Aceptar</button>
  </div>
</div> -->

<app-modal-info #modalInfo [title]="modalTitle" [message]="modalMessage" [buttonText]="'Aceptar'"></app-modal-info>


